import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const PerformLogo = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#FCEDBE"/>
      <circle cx="14" cy="14" r="9.33333" fill="#FECF32"/>
      <path d="M4.66663 14C4.66663 19.1547 8.8453 23.3334 14 23.3334C17.1228 23.3334 19.8874 21.7997 21.5817 19.4445L14 14.7778V4.66669C8.8453 4.66669 4.66663 8.84536 4.66663 14Z" fill="#FFAD00"/>
      <path d="M7.77783 18.7126C7.77783 18.2578 8.14654 17.8891 8.60136 17.8891C9.05618 17.8891 9.42489 18.2578 9.42489 18.7126V23.3335H7.77783V18.7126Z" fill="#C72037"/>
      <path d="M14.9601 17.157C14.9601 16.7022 15.3288 16.3335 15.7836 16.3335C16.2384 16.3335 16.6071 16.7022 16.6071 17.157V23.3335H14.9601V17.157Z" fill="#C72037"/>
      <path d="M11.3689 14.0459C11.3689 13.5911 11.7376 13.2224 12.1924 13.2224C12.6472 13.2224 13.016 13.5911 13.016 14.0459V23.3335H11.3689V14.0459Z" fill="#C72037"/>
      <path d="M18.5513 12.4904C18.5513 12.0356 18.92 11.6669 19.3748 11.6669C19.8296 11.6669 20.1983 12.0356 20.1983 12.4904V23.3335H18.5513V12.4904Z" fill="#C72037"/>
      </svg>
   </SvgIcon>
  );
}

export default PerformLogo;